enum IntegrationSyncStatus {
  COMPLETED = "completed",
  ERROR = "errored",
  RUNNING = "running",
  INITIALIZING = "initializing",
}

export default IntegrationSyncStatus;
